import { createConsumer } from "@rails/actioncable"

// Create a single ActionCable consumer instance
// Uses the session cookie for authentication automatically
export const consumer = createConsumer("/cable")
